import Icon from 'veui/components/Icon'
import { IconVideo } from 'dls-icons-vue'

Icon.register('video', IconVideo)
